import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {ContractFieldGroup} from '../../../contract/interfaces/ContractFieldGroup';

@Injectable()
export class ContractFieldGroupService {


  private route = 'contractfieldgroups';
  constructor(private http: AuthHttp) { }

  public getContractFieldGroups(contractId: number = 5, type: number, withFields: boolean = false): Promise<ContractFieldGroup[]> {
    const params = {
      contract_id: contractId
    };
    if (type)
      params['type'] = type;
    if (withFields)
      params['withFields'] = withFields;
    return this.http.get(`${environment.baseUrl}${this.route}`, { params: params})
      .map((res) => res.json()).toPromise();
  }

  public createContractFieldGroup(contractFieldGroup) {
    return this.http.post(`${environment.baseUrl}${this.route}`, contractFieldGroup)
      .map((res) => res.json()).toPromise();
  }

  public removeContractFieldGroup(id) {
    return this.http.delete(`${environment.baseUrl}${this.route}/${id}`)
      .map((res) => res.json()).toPromise();
  }

  public updateManyContractFieldGroups(updatedItems) {
    return this.http.put(`${environment.baseUrl}${this.route}`, updatedItems)
      .map((res) => res.json())
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/services/contract-field-group/contract-field-group.service.ts